import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ICostsStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ICostsStatsResponse>,
  IPathBaseParam,
  object
>("stores.employeeCosts.stats");

export const stats = {
  ...getApis,
};
